import CommissionRelease from '../components/commissionRelease/index';

const superDistributorRoutes = [
];

export  default superDistributorRoutes;
